<template>
    <div class="rule-group-outer-table">
        <section
            v-for="(ruleGroup, index) in ruleGroupOuterInner"
            :key="ruleGroup.id"
            data-qa="rule-group-section"
        >
            <section class="rule-group-outer-title" data-qa="rule-group-title">
                <span v-if="index === 0">
                    {{ $t('funnel.debug.ruleGroupOuter') }}
                </span>

                <span v-else>
                    {{ $t('funnel.debug.ruleGroupInner') }}
                </span>
            </section>

            <DsTableGrid
                ref="ruleGroupRef"
                :data="ruleGroup"
                data-qa="rule-group-table"
            >
                <DsTableGridColumn
                    :label="$t('funnel.edit.decision.diamond.debug.label.id')"
                    prop="Id"
                    width="60"
                    data-qa="rule-group-column-id"
                />

                <DsTableGridColumn
                    :label="$t('funnel.edit.decision.diamond.debug.label.rule.group.id')"
                    prop="RuleGroupId"
                    width="60"
                    data-qa="rule-group-column-rule-group-id"
                />

                <DsTableGridColumn
                    :label="$t('funnel.edit.decision.diamond.debug.label.draft.order')"
                    prop="Order"
                    width="60"
                    data-qa="rule-group-column-order"
                />

                <DsTableGridColumn
                    :label="$t('funnel.edit.decision.diamond.debug.label.draft.comparison')"
                    prop="Comparison"
                    width="60"
                    data-qa="rule-group-column-comparison"
                />

                <DsTableGridColumn
                    :label="$t('funnel.edit.decision.diamond.debug.label.content.publishing.id')"
                    prop="ContentPublishingId"
                    width="120"
                    data-qa="rule-group-column-content-publishing-id"
                />

                <DsTableGridColumn
                    :label="$t('funnel.edit.decision.diamond.debug.label.date.created')"
                    prop="DateCreated"
                    width="100"
                    data-qa="rule-group-column-date-created"
                />

                <DsTableGridColumn
                    :label="$t('funnel.edit.decision.diamond.debug.label.last.updated')"
                    prop="LastUpdated"
                    width="100"
                    data-qa="rule-group-column-last-updated"
                />
            </DsTableGrid>
        </section>
    </div>
</template>

<script>
export default {
    props: {
        ruleGroupOuterInner: {
            type: Array,
            required: true,
        },
    },
};

</script>

<style lang="scss" scoped>
.rule-group-outer-table {
    :deep(th .cell) {
        word-wrap: break-word;
        white-space: break-spaces;
    }

    .rule-group-outer-title {
        font-weight: bold;
        margin: $spacing-250 0 $spacing-250 0;
    }
}
</style>
